function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6 0C19.1 0 0 19.1 0 42.6s19.1 42.6 42.6 42.6 42.6-19.1 42.6-42.6C85.3 19.1 66.2 0 42.6 0zm0 5.6c20.5 0 37.1 16.6 37.1 37.1s-16.6 37-37.1 37S5.5 63.1 5.5 42.6c0-20.4 16.6-37 37.1-37zM26.9 25c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6c-.1-3.1-2.5-5.6-5.6-5.6zm31.5 0c-3.1 0-5.6 2.5-5.6 5.6 0 3.1 2.5 5.6 5.6 5.6 3.1 0 5.6-2.5 5.6-5.6 0-3.1-2.5-5.6-5.6-5.6zM42.6 47.3c-9.1 0-17.6 4.7-22.7 12.3-.9 1.3-.6 3 .7 3.9 1.3.9 3 .6 3.9-.7l.1-.1c6.4-10 19.7-12.9 29.7-6.5 2.6 1.7 4.8 3.9 6.5 6.5.9 1.3 2.6 1.6 3.9.7 1.2-.9 1.6-2.5.8-3.8-5.2-7.6-13.7-12.3-22.9-12.3z",
  fill: "#333333"
});

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.3 85.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.ad0e0e50.svg";
export { ForwardRef as ReactComponent };